import { useMagasinStore } from "@/store/magasin";

export default defineNuxtPlugin(({ $pinia }) => {
  const magasinStore = useMagasinStore($pinia);
  const config = useRuntimeConfig();
  const nuxtApp = useNuxtApp();
  let alreadyCalled = false;
  const refreshShopData = async () => {
    if (magasinStore.lastUpdatedTime + config.public.API_DRIVE_CACHE_RELOAD_DELAY_MAGASIN < Date.now() && !nuxtApp.isHydrating && !alreadyCalled) {
      await magasinStore.fetchMagasin(magasinStore.id);
      magasinStore.setLastUpdatedTime();
      alreadyCalled = false;
    }
  }
  return {
    provide: {
      refreshShopData
    }
  }
});
